
import React from "react";
import PostedInvoices from "../Components/Accounts/PostedInvoice"

export function PostedInvoice() {
  return (
    <PostedInvoices />
  );
}